import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAppSelector } from '@hooks/redux'
import LoadingScreen from '@components/common/LoadingScreen'

interface ProtectedRouteProps {
  children: React.ReactNode
  // When set, also requires the signed-in user to be an admin (User.admin), redirecting
  // non-admins back to Home rather than rendering the (system-wide, not personal) page.
  requireAdmin?: boolean
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin }) => {
  const { isAuthenticated, isLoading, user } = useAppSelector((state) => state.auth)
  const location = useLocation()

  if (isLoading) {
    return <LoadingScreen message="Authenticating..." />
  }

  if (!isAuthenticated) {
    // Redirect to sign-in page with return URL
    return (
      <Navigate
        to="/auth/sign-in"
        state={{ from: location }}
        replace
      />
    )
  }

  if (requireAdmin && !user?.is_staff) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
